export default __webpack_public_path__ + "static/076-b3a7dd6fc696a93ae3683ec7903fe463.jpg";